var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivetabTipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 10,
    viewBox: "0 0 40 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5614 7.96244C18.942 9.36862 21.1465 9.34246 22.4963 7.90232L24.6352 5.6202C26.2594 3.88726 27.9524 2.47624 29.968 1.50162C31.9869 0.525378 34.3022 -1.45179e-06 37.1546 -1.20242e-06L40 -9.53674e-07L40 0.999999L37.1546 0.999999C34.4318 0.999999 32.2686 1.49994 30.4033 2.40189C28.5347 3.30545 26.938 4.6255 25.3648 6.30404L23.2259 8.58616C21.488 10.4405 18.6275 10.4756 16.8478 8.66303C16.823 8.6377 16.7984 8.61208 16.7741 8.58616L14.6352 6.30404C13.062 4.6255 11.4653 3.30545 9.59671 2.40189C7.73145 1.49993 5.56821 0.999996 2.84535 0.999996L7.86805e-07 0.999996L8.74228e-07 -4.45059e-06L2.84535 -4.20184e-06C5.69776 -3.95247e-06 8.01315 0.525376 10.032 1.50161C12.0476 2.47624 13.7406 3.88725 15.3648 5.6202L17.5037 7.90232C17.5227 7.92259 17.542 7.94263 17.5614 7.96244Z",
    fill: "#D4D4D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4963 7.90232C21.1466 9.34246 18.9421 9.36862 17.5615 7.96244C17.542 7.94263 17.5228 7.92259 17.5038 7.90232L15.3649 5.6202C13.7407 3.88725 12.0477 2.47624 10.0321 1.50161C8.0165 0.52697 5.70538 0.00171271 2.85938 0H37.1547C34.3023 0 31.9869 0.525378 29.968 1.50162C27.9525 2.47624 26.2594 3.88726 24.6352 5.6202L22.4963 7.90232Z",
    fill: "#EAF6FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivetabTipIcon);
export default __webpack_public_path__ + "static/media/activetab-tip-icon.55de004689fc1b8d115ea1002974d45c.svg";
export { ForwardRef as ReactComponent };